import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ProfileTypes } from '@sda/enums';
import { getActPath, getVenuePath } from '@sda/utils/url';
import type { PublicAct } from '@sda/interfaces/act';
import type { PublicVenue } from '@sda/interfaces/venue';

export const useProfileLink = (
  profileType: ProfileTypes,
  profileData: PublicAct | PublicVenue,
  onClick?: React.MouseEventHandler<HTMLAnchorElement>,
) => {
  const profileUrl = profileType === ProfileTypes.ACT
    ? getActPath(profileData.vanityUrl)
    : getVenuePath(profileData.vanityUrl);

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }
  }, [onClick]);

  return {
    to: profileUrl,
    component: Link,
    onClick: handleClick,
  };
};
